import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import "../css/Contatti.css";
import { useContacts } from "../context/ContactsContext";
import API from "../config/api";

// Icon paths from public/assets
const phoneIcon = "/assets/icons/phone.png";
const emailIcon = "/assets/icons/email.png";

const Contatti = () => {
  const { contacts } = useContacts();
  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    email: "",
    messaggio: "",
  });

  // Prefill message from query param ?message=...
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const msg = params.get("message");
      if (msg) {
        setFormData((prev) => ({
          ...prev,
          messaggio: decodeURIComponent(msg),
        }));
      }
    } catch (err) {
      // ignore
    }
  }, []);

  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false,
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !formData.nome ||
      !formData.cognome ||
      !formData.email ||
      !formData.messaggio
    ) {
      setFormStatus({
        submitted: false,
        error: true,
        message: "Compila tutti i campi per continuare.",
      });
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setFormStatus({
        submitted: false,
        error: true,
        message: "Inserisci un indirizzo email valido.",
      });
      return;
    }

    // Send to backend API
    try {
      const response = await fetch(API.ENDPOINTS.CONTACT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setFormStatus({
          submitted: true,
          error: false,
          message:
            "Grazie! La tua richiesta è stata inviata con successo. Ti contatteremo presto.",
        });

        // Reset form
        setFormData({
          nome: "",
          cognome: "",
          email: "",
          messaggio: "",
        });
      } else {
        setFormStatus({
          submitted: false,
          error: true,
          message:
            result.error || "Si è verificato un errore. Riprova più tardi.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormStatus({
        submitted: false,
        error: true,
        message: "Si è verificato un errore di connessione. Riprova più tardi.",
      });
    }
  };

  return (
    <div>
      <Navbar />
      <div className="contatti-container">
        <h1>Contattaci</h1>

        <div className="contatti-content">
          {/* Contact Info Section */}
          <div className="contact-info-section">
            <div className="info-card card">
              <h2 >Come raggiungerci</h2>
              <p>
                Siamo a tua disposizione per qualsiasi informazione, consulenza
                o richiesta di preventivo gratuito.
              </p>

              <div className="contact-methods">
                <a href={contacts.PHONE_TEL} className="btn btn--primary contact-button">
                  <img src={phoneIcon} alt="Telefono" className="icon" />
                  <span className="text">
                    <strong>Chiamaci</strong>
                    <small>{contacts.PHONE_DISPLAY}</small>
                  </span>
                </a>

                <a href={contacts.MAILTO} className="btn btn--secondary contact-button">
                  <img src={emailIcon} alt="" className="icon" />
                  <span className="text">
                    <strong>Scrivici</strong>
                    <small>{contacts.CONTACT_EMAIL}</small>
                  </span>
                </a>
              </div>

              <div className="address-section">
                <h3 className="section-subtitle">Indirizzo</h3>
                <p>
                  <strong>Via Bronzino 24/B rosso</strong>
                  <br />
                  (accanto al 108)
                  <br />
                  50142 Firenze
                </p>
              </div>

              <div className="hours-section">
                <h3 className="section-subtitle">Orari di Apertura</h3>
                <p>
                  Lunedì - Venerdì: 08–12:30, 15–18
                  <br />
                  Sabato: Chiuso
                  <br />
                  Domenica: Chiuso
                </p>
                <div className="hours-note">
                  Disponibilità di apertura in altri orari su appuntamento.
                </div>
              </div>
            </div>
          </div>

          {/* Quote Request Form */}
          <div className="form-section">
            <div className="form-card card">
              <h2>Richiedi un Preventivo</h2>
              <p className="form-description">
                Compila il modulo sottostante e ti contatteremo il prima
                possibile con un preventivo personalizzato.
              </p>

              {formStatus.message && (
                <div
                  className={`form-message ${
                    formStatus.error ? "error" : "success"
                  }`}
                >
                  {formStatus.message}
                </div>
              )}

              <form onSubmit={handleSubmit} className="quote-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="nome">Nome *</label>
                    <input
                      type="text"
                      id="nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      placeholder="Il tuo nome"
                      required
                      className="form-input"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="cognome">Cognome *</label>
                    <input
                      type="text"
                      id="cognome"
                      name="cognome"
                      value={formData.cognome}
                      onChange={handleChange}
                      placeholder="Il tuo cognome"
                      required
                      className="form-input"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="tua@email.com"
                    required
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="messaggio">Messaggio *</label>
                  <textarea
                    id="messaggio"
                    name="messaggio"
                    value={formData.messaggio}
                    onChange={handleChange}
                    placeholder="Descrivi la tua richiesta..."
                    rows="6"
                    required
                    className="form-textarea"
                  ></textarea>
                </div>

                <button type="submit" className="submit-button">
                  Invia Richiesta
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contatti;
